const LOGIN_TOKEN = 'LOGIN_TOKEN';

export const getLoginToken = () => {
	return localStorage.getItem(LOGIN_TOKEN);
};

export const setLoginToken = token => {
	localStorage.setItem(LOGIN_TOKEN, token);
};

export const removeLoginToken = () => {
	localStorage.removeItem(LOGIN_TOKEN);
};
